import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

class UISlider {
    
    constructor() {
        
        if(ootlahData.page=="activities" || ootlahData.page=="search"){
            this.events();
            var range = document.getElementById('range');
            

            noUiSlider.create(range, {
                start: [Number(jQuery('#min_price_set').val()), Number(jQuery('#max_price_set').val())],
                // A linear range from 0 to 15 (16 values)
                range: { min: Number(jQuery('#min_price_set').val()), max: Number(jQuery('#max_price_set').val()) },
                // steps of 1
                step: 1,
                tooltips: true,
                // Display colored bars between handles
                connect: true,

            });

            
        }


    }

    events() {
        jQuery('#reset-filter-price').on("click", this.resetFilterByPrice.bind(this));
    }

    resetFilterByPrice(e){
        var maxPrice = jQuery('#max_price_set').val();
        var minPrice = jQuery('#min_price_set').val();
        range.noUiSlider.set([minPrice,maxPrice]);
    }
}

export default UISlider